// extracted by mini-css-extract-plugin
module.exports = {"administration-service-fields":"_1uYX1YTXUKtBB3LE-4y0Q-"};